/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Flags Scheduling API
 * This page documents how to use Optimizely Flags Scheduling API. These APIs allow you to turn a flag on/off, turn a  rule on/off, change the traffic allocation of a rule and change the audience conditions of a rule. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FlagScheduleActionSubject,
    FlagScheduleActionSubjectFromJSON,
    FlagScheduleActionSubjectFromJSONTyped,
    FlagScheduleActionSubjectToJSON,
} from './';

/**
 * 
 * @export
 * @interface FlagScheduleAction
 */
export interface FlagScheduleAction {
    /**
     * 
     * @type {FlagScheduleActionSubject}
     * @memberof FlagScheduleAction
     */
    subject: FlagScheduleActionSubject;
    /**
     * The element to be changed.
     * @type {string}
     * @memberof FlagScheduleAction
     */
    changed_element?: string;
    /**
     * The value for changed_element.
     * @type {object}
     * @memberof FlagScheduleAction
     */
    value: object;
}

export function FlagScheduleActionFromJSON(json: any): FlagScheduleAction {
    return FlagScheduleActionFromJSONTyped(json, false);
}

export function FlagScheduleActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlagScheduleAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subject': FlagScheduleActionSubjectFromJSON(json['subject']),
        'changed_element': !exists(json, 'changed_element') ? undefined : json['changed_element'],
        'value': json['value'],
    };
}

export function FlagScheduleActionToJSON(value?: FlagScheduleAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subject': FlagScheduleActionSubjectToJSON(value.subject),
        'changed_element': value.changed_element,
        'value': value.value,
    };
}


